import { render, staticRenderFns } from "./singleupdate.vue?vue&type=template&id=17e9bc0d&scoped=true&"
import script from "./singleupdate.vue?vue&type=script&lang=js&"
export * from "./singleupdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17e9bc0d",
  null
  
)

export default component.exports